import { Box, Grid, styled } from '@mui/material';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

const VideosContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: 10,
  gap: 12,
  cursor: 'pointer',
  flexWrap: 'wrap',
  '& .videoItem': {
    width: 200,
    height: 200,
    borderRadius: 12,
    backgroundColor: 'rgba(235, 234, 255, 1)',
    position: 'relative',

    '& .removeIconCnt': {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1000,
      display: 'none',
      '& .removeIcon': {
        color: '#a52424',
      },
    },
    '&: hover': {
      '& .removeIconCnt': {
        display: 'block',
      },
    },

    '& .playBtnCnt': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      '& svg': {
        color: 'white',
        height: 80,
        width: 80,
      },
      '& svg path:first-of-type': {
        color: 'white', // Outer circle
      },
      '& svg path:last-of-type': {
        color: 'white', // Play button
      },
    },
    '& video': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 12,
    },
  },
}));

const ChecklistLogReportAppendixVideos = function ({
  appendixAttachment,
  attachmentIndex,
  previewAttachment,
}) {
  return (
    <Grid item className="">
      <Box
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '19.12px',
          marginBottom: '8px',
          color: 'rgba(33, 33, 33, 1)',
        }}
      >
        Video {attachmentIndex + 1}
      </Box>
      <VideosContainer>
        <Box
          className="videoItem"
          key={appendixAttachment?.url + '_' + attachmentIndex}
          onClick={() => previewAttachment(attachmentIndex)}
        >
          <Box className="playBtnCnt">
            <PlayCircleFilledIcon />
          </Box>
          <video src={appendixAttachment?.url} />
        </Box>
      </VideosContainer>
    </Grid>
  );
};

export default ChecklistLogReportAppendixVideos;
